import { render, staticRenderFns } from "./PlaceOrderDelivery.vue?vue&type=template&id=7d3b9f06&scoped=true&"
import script from "./PlaceOrderDelivery.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderDelivery.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOrderDelivery.vue?vue&type=style&index=0&id=7d3b9f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3b9f06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow})
